
export const Config = {
  apiUrl: {
    dev: process.env.REACT_APP_DEV_API_URL || '',
    prod: process.env.REACT_APP_API_URL || ''
  }
};
